import PropTypes from 'prop-types';

const keySystemConfigShape = PropTypes.shape({
  defaultLicenseUrl: PropTypes.string,
  getLicenseUrl: PropTypes.func,
  getLicenseHeaders: PropTypes.func,
  options: PropTypes.shape({}),
});
export const keySystemsConfigShape = PropTypes.shape({
  playready: keySystemConfigShape,
  widevine: keySystemConfigShape,
  fairplay: keySystemConfigShape,
  preferredKeySystems: PropTypes.arrayOf(PropTypes.string),
  licenseRequest: PropTypes.shape({
    retries: PropTypes.number,
    timeout: PropTypes.number,
  }),
});

export const bufferConfigShape = {
  backward: PropTypes.number,
  forward: PropTypes.number,
};

export const sourceShape = PropTypes.shape({
  dash: PropTypes.string,
  hls: PropTypes.string,
  smooth: PropTypes.string,
  isPrimary: PropTypes.bool,
});

export const restrictionsShape = PropTypes.shape({
  maxHeight: PropTypes.number,
  minHeight: PropTypes.number,
  maxWidth: PropTypes.number,
  minWidth: PropTypes.number,
  minBandwidth: PropTypes.number,
  maxBandwidth: PropTypes.number,
});
